class LatepointPaymentsBraintreeAddon {
	constructor(){
		this.hostedFieldsInstance = null;
		this.threeDSecure = null;
		this.ready();
	}

	ready(){
		jQuery(document).ready(() => {
			jQuery('body').on('latepoint:submitBookingForm', '.latepoint-booking-form-element', (e, data) => {
	      if(!latepoint_helper.demo_mode && data.is_final_submit){
	      	let payment_method = jQuery(e.currentTarget).find('input[name="booking[payment_method]"]').val();
	      	switch(payment_method){
	      		case 'card':
	      		break;
	      	}
	      }
			});

			jQuery('body').on('latepoint:nextStepClicked', '.latepoint-booking-form-element', (e, data) => {
	      if(!latepoint_helper.demo_mode && (data.current_step == 'payment')){
	      	let payment_method = jQuery(e.currentTarget).find('input[name="booking[payment_method]"]').val();
	      	switch(payment_method){
	      		case 'card':
			      	latepoint_add_action(data.callbacks_list, () => {
								return this.createToken(jQuery(e.currentTarget), 'card');
			      	});
	      		break;
	      	}
	      }
			});

			jQuery('body').on('latepoint:initPaymentMethod', '.latepoint-booking-form-element', (e, data) => {
				if(data.payment_method == 'paypal'){
					latepoint_add_action(data.callbacks_list, () => {
						return this.initPaypalButton(jQuery(e.currentTarget));
					});
				}
				if(data.payment_method == 'card'){
					latepoint_add_action(data.callbacks_list, () => {
						return this.initCreditCardForm(jQuery(e.currentTarget));
	      	});
				}
			});

			jQuery('body').on('latepoint:initStep:payment', '.latepoint-booking-form-element', (e, data) => {
				
			});
		});
	}


  getPaymentAmount($booking_form_element, payment_method, payload){
    let deferred = jQuery.Deferred();

    var data = { 
    	action: 'latepoint_route_call', 
    	route_name: $booking_form_element.find('.lp-payment-method-content[data-payment-method="'+payment_method+'"]').data('init-route'), 
    	params: $booking_form_element.find('.latepoint-form').serialize(), 
    	layout: 'none', 
    	return_format: 'json' 
    }
    jQuery.ajax({
      type : "post",
      dataType : "json",
      url : latepoint_helper.ajaxurl,
      data : data,
      success: (data) => {
        if(data.status === "success"){
        	deferred.resolve({amount: data.message, payload: payload});
        }else{
        	deferred.reject({message: data.message});
        }
      },
      error: function(request, status, error){
      	deferred.reject({message: error});
      }
    });

    return deferred;
  }

	createToken($booking_form_element, payment_method){
    let deferred = jQuery.Deferred();
    this.hostedFieldsInstance.tokenize().then(payload => {
	    return this.getPaymentAmount($booking_form_element, payment_method, payload);
    }).then((paymentData) => {
			return this.threeDSecure.verifyCard({
			  onLookupComplete:  (data, next) => {
			    next();
			  },
			  amount: paymentData.amount,
			  nonce: paymentData.payload.nonce,
			  bin: paymentData.payload.details.bin,
			  email: $booking_form_element.find('input[name="customer[email]"]').val()
			})
	  }).then(payload => {
	  	if(payload.liabilityShifted || (!payload.liabilityShifted && !payload.liabilityShiftPossible)){
		  	$booking_form_element.find('input[name="booking[payment_token]"]').val(payload.nonce);
		  	deferred.resolve();
	  	}else{
		  	deferred.reject({message: '3D Secure Card Validation Failed'});
	  	}
	  }).catch(err => {
    	if(err.code == 'HOSTED_FIELDS_FIELDS_INVALID' && err.details.invalidFields){
    		jQuery.each(err.details.invalidFields, function(key, field){
    			$booking_form_element.find(field).addClass('braintree-hosted-fields-invalid');
    		});
    	}
    	deferred.reject({message: err.message});
	  });
	  return deferred;
	}




	initPaypalButton($booking_form_element){
    let deferred = jQuery.Deferred();
  	let payment_amount = latepoint_get_paypal_payment_amount($booking_form_element);

		braintree.client.create({ authorization: latepoint_helper.braintree_client_token})
			.then(function (clientInstance) {
			  // Create a PayPal Checkout component.
			  return braintree.paypalCheckout.create({
			    client: clientInstance
			  });
			})
			.then(function (paypalCheckoutInstance) {
			  return paypalCheckoutInstance.loadPayPalSDK({
			    currency: latepoint_helper.paypal_payment_currency,
			    intent: 'authorize'
			  });
			})
			.then(function (paypalCheckoutInstance) {
			  return paypal.Buttons({
				  createOrder: function() {
				    return paypalCheckoutInstance.createPayment({
	            flow: 'checkout', // Required
	            amount: payment_amount, // Required
	            currency: latepoint_helper.paypal_payment_currency,
	            intent: 'authorize' // Required
	            // Your PayPal options here. For available options, see
	            // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
				    });
				  },
				  onApprove: function(data, actions) {
						$booking_form_element.removeClass('step-content-loaded').addClass('step-content-loading');
						let $latepoint_form = $booking_form_element.find('.latepoint-form');
				    // Authorize the transaction
				    return paypalCheckoutInstance.tokenizePayment(data).then(function(payload) {
				      // Get the authorization id
				      $booking_form_element.find('input[name="booking[payment_token]"]').val(payload.nonce);
				      $latepoint_form.submit();
				    });
				  }
				}).render($booking_form_element.find('.lp-paypal-btn-trigger')[0]);
			})
			.then(function () {
			  deferred.resolve();
			});
			return deferred;
	}

	initCreditCardForm($booking_form_element){
    let deferred = jQuery.Deferred();
		braintree.client.create({ authorization: latepoint_helper.braintree_client_token })
			.then((clientInstance) => {
					return Promise.all([
				  braintree.hostedFields.create({
				    client: clientInstance,
				    styles: {
				      'input': {
				        'font-size': '14px',
				        'font-family': latepoint_helper.body_font_family,
				        'font-weight': '500',
				        'color': '#fff',
				      },
				      ':focus': {
				        'color': '#fff'
				      },
				      '::placeholder': {
				        'color': '#7d89b1'
				      },
				      '.valid': {
				        'color': '#fff'
				      },
				      '.invalid': {
				        'color': '#ff5a16'
				      }
				    },
				    fields: {
				    	postalCode: {
				    		container: $booking_form_element.find('#payment_zip')[0],
				        placeholder: $booking_form_element.find('#payment_zip').data('placeholder')
				    	},
				    	cardholderName: {
				    		container: $booking_form_element.find('#payment_name_on_card')[0],
				        placeholder: $booking_form_element.find('#payment_name_on_card').data('placeholder')
				    	},
				      number: {
				        container: $booking_form_element.find('#payment_card_number')[0],
				        placeholder: $booking_form_element.find('#payment_card_number').data('placeholder')
				      },
				      cvv: {
				        container: $booking_form_element.find('#payment_card_cvc')[0],
				        placeholder: $booking_form_element.find('#payment_card_cvc').data('placeholder')
				      },
				      expirationDate: {
				        container: $booking_form_element.find('#payment_card_expiration')[0],
				        placeholder: $booking_form_element.find('#payment_card_expiration').data('placeholder')
				      },
				    }
				  }),
				  braintree.threeDSecure.create({
				    client: clientInstance,
			      version: 2
			    })
			   ]);
				})
			.then(instances => {
	    	this.hostedFieldsInstance = instances[0];
	    	this.threeDSecure = instances[1];
      	latepoint_show_next_btn($booking_form_element);
      	deferred.resolve();
	    	})
	    .catch(err => {
	    	deferred.reject({message: err});
	    });
    return deferred;
	}
}

let latepointPaymentsBraintreeAddon = new LatepointPaymentsBraintreeAddon();